import React from "react";

export default function BrandType(props) {
  const { handleBrandSelection, item } = props;
  const { icon, name } = item;
  
  return (
    <li className="nav-item pointer" onClick={() => handleBrandSelection(item)}>
      <a className="nav-link" href="#" onClick={e => e.preventDefault()
      }>
        {icon && (
          <img src={`data:image/png;base64,${icon && icon}`} alt="brand_icon" />
        )}
        {name && name}
      </a>
    </li>
  );
}
